import {
  Box,
  Button,
  DialogActions,
  FormHelperText,
  IconButton,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import DatePicker, {
  DayValue,
} from "@hassanmojab/react-modern-calendar-datepicker";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import ClockSVG from "../../../media/images/icons/clock";
import ModalLayout from "../ModalLayout";
import MultipleSimple from "../../../media/images/icons/multiple-simple";

export default function CustomTimepicker(props: {
  hasError?: string;
  label: string;
  error?: boolean;
  errorMessage: any;
  value: any;

  selectedValue: {
    hour: string;
    min: string;
  } | null;
  setSelectedValue: React.Dispatch<
    React.SetStateAction<{
      hour: string;
      min: string;
    } | null>
  >;

  onChange: (value: any) => void;
  handleResetDate?: () => void;
}) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  // const [selectedValue, setSelectedValue] = useState<{
  //   hour: string;
  //   min: string;
  // } | null>(null);

  const handleFocus = (event: any) => {
    event.preventDefault();
    event.target.blur();
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      {/* <Typography variant="body2">{props.label}</Typography> */}
      <Box
        onClick={() => setOpen(true)}
        sx={{
          height: "48px",
          border: "1px solid gray",
          display: "flex",
          alignItems: "center",
          paddingX: "8px",
          borderRadius: "8px",
        }}
      >
        {props.selectedValue && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              props.handleResetDate && props.handleResetDate();
            }}
            aria-label="delete"
            color="primary"
          >
            <MultipleSimple size={22} color={theme.palette.error.main} />
          </IconButton>
        )}
        <TextField
          value={
            props.selectedValue
              ? props.selectedValue.hour + ":" + props.selectedValue.min
              : props.label
          }
          //   onClick={handleClickOpen}
          // placeholder={props.label}
          onFocus={handleFocus}
          sx={{
            width: "100%",
            height: "100%",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none !important",
              outline: "none !important",
              borderRadius: "0px",
              padding: 0,
            },
            "& .MuiInputBase-input": {
              height: "100%",
              border: "none !important",
              outline: "none !important",
              padding: 0,
              fontSize: "14px",
              color: "textColor.main",

              "&::placeholder": {
                fontSize: "14px",
                color: "textColor.main !IMPORTANT",
              },
            },
            "& .MuiInputBase-root": {
              border: "none !important",
              outline: "none !important",
              height: "100%",
              paddingX: "0px",
              color: "textColor.main",
            },
            border: "none",
          }}
        />
        <ClockSVG color={theme.palette.textColor.main} />
      </Box>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        localeText={{
          cancelButtonLabel: "انصراف",
          okButtonLabel: "تایید",
        }}
      >
        {
          <style>{`
                    .MuiStack-root {
                display: none !important;
              }
                .Calendar{
                    `}</style>
        }
        <DemoContainer
          sx={{
            "& .MuiStack-root": {
              display: "none !important",
            },
          }}
          components={["MobileTimePicker"]}
        >
          <MobileTimePicker
            onClose={() => setOpen(false)}
            sx={{
              "& .MuiStack-root": {
                display: "none !important",
              },
              "& .MuiInputBase-input": {
                height: "100%",
                border: "none !important",
                outline: "none !important",
                padding: 0,
                fontSize: "14px",
                color: "textColor.main",

                "&::placeholder": {
                  fontSize: "12px",
                },
              },
            }}
            open={open}
            ampm={false}
            onAccept={(newValue) => {
              if (newValue) {
                props.setSelectedValue({
                  hour:
                    newValue.hour() < 10
                      ? "0" + newValue.hour().toString()
                      : newValue.hour().toString(),
                  min:
                    newValue.minute() < 10
                      ? "0" + newValue.minute().toString()
                      : newValue.minute().toString(),
                });

                props.onChange(
                  `${
                    newValue.hour() < 10
                      ? "0" + newValue.hour().toString()
                      : newValue.hour().toString()
                  }:${
                    newValue.minute() < 10
                      ? "0" + newValue.minute().toString()
                      : newValue.minute().toString()
                  }`
                );
              }
            }}
            // onChange={
            //   (newValue) => {
            //     if (newValue)
            //       props.setSelectedValue({
            //         hour:
            //           newValue.hour() < 10
            //             ? "0" + newValue.hour().toString()
            //             : newValue.hour().toString(),
            //         min:
            //           newValue.minute() < 10
            //             ? "0" + newValue.minute().toString()
            //             : newValue.minute().toString(),
            //       });
            //   }
            //   //   formik.setFieldValue(
            //   //     'workStartTime',
            //   //     newValue?.toISOString()
            //   //   )
            // }
            // value={dayjs(new Date(formik.values.workStartTime))}
            defaultValue={dayjs(new Date())}
          />
        </DemoContainer>
      </LocalizationProvider>
      {props.error && (
        <Typography
          style={{
            padding: "0px",
            margin: "0px",
            color: "red",
            direction: "rtl",
            textAlign: "right",
            fontSize: 13,
          }}
        >
          {props.errorMessage}
        </Typography>
      )}
    </Box>
  );
}

function CustomActionBar(props: any) {
  const { onAccept, onClear, onCancel, onSetToday, actions } = props;

  return (
    <DialogActions>
      {actions.includes("cancel") && <Button onClick={onCancel}>لغو</Button>}
      {actions.includes("accept") && <Button onClick={onAccept}>تایید</Button>}
    </DialogActions>
  );
}
